import { AfterViewInit, Component, ElementRef, Input, ViewChild, ViewEncapsulation } from '@angular/core';

import { buildAddressLine1, buildCityStateLine } from '@core/helper/addresses';

import { MapService } from '@core/helper/map.service';
import { Parcel } from '@shared/models';
import { ParcelSelectionStore } from '../locate-property-page/parcel-selection.store';

@Component({
  selector: 'fc-parcel-info',
  templateUrl: './parcel-info.component.html',
  styleUrls: ['./parcel-info.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class ParcelInfoComponent implements AfterViewInit {
  @ViewChild('dataContainer', { static: false }) dataContainer: ElementRef;
  @Input() parcel: Parcel;
  @Input() readOnly: boolean;
  @Input() isAdmin: boolean;

  constructor(readonly parcelSelection: ParcelSelectionStore, readonly mapService: MapService) {}

  ngAfterViewInit(): void {
  }

  removeParcel(): void {
    this.parcelSelection.remove(this.parcel.llUuid);
  }

  centerOnParcel() {
    this.mapService.flyToBoundingBox(this.parcel.feature);
  }

  buildAddressLine1(parcel: Parcel): string {
    return buildAddressLine1(parcel.feature.properties);
  }

  buildAddressCityState(parcel: Parcel): string {
    return buildCityStateLine(parcel.feature.properties);
  }

  get approxSize() {
    return this.parcel.getAreaInAcres().toLocaleString('us-EN', { maximumFractionDigits: 2 });
  }
}
